import { PostCoreController } from './post-core.controller'

function postCore () {
  return {
    restrict: 'E',
    templateUrl: '/posts/directives/post-core/post-core-directive.html?$$REVISION$$',
    controller: PostCoreController
  }
}

export { postCore }
